<template>
    <b-row class="function py-5">
        <b-col cols="12"  lg="12">
            <p class="function-titulo text-center" v-html="content.titulo"></p>
            
        </b-col>
        <b-col cols="12"  lg="12">
            <b-row class="mt-5 pb-5 function-content-block" >
               
                <Block :content="content.blocks.shops"/>
                <Block :content="content.blocks.log"/>
                <Block :content="content.blocks.capta"/>
                <Block :content="content.blocks.eleva"/>
                
            </b-row>
        </b-col>
        <b-col cols="12"  lg="12" class="mt-5 pt-5 function-spase">
        </b-col>
    </b-row>
</template>
<script>
    import Block from '@/components/Block'

    export default {
        name: 'section-solutions',
        components: {
            Block
        },
        props: {
            content: Object
        }
    }
</script>
<style scoped>
</style>